// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SafetyAnchorPointModel from '../../model/safety-anchor-point-model';
import SafetyAnchorPointDTO from '../dto/safety-anchor-point-dto';
import dtoSchema from '../schemas/safety-anchor-point-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SafetyAnchorPointModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SafetyAnchorPointDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.siHaDocumentationId = data.siHaDocumentationId;
      this.safetyHookId = data.safetyHookId;
      this.name = data.name ?? undefined;
      this.screwLength = data.screwLength;
      this.remark = data.remark ?? undefined;
      this.isInstalledOnCounterBatten = data.isInstalledOnCounterBatten;
      this.installationRemark = data.installationRemark ?? undefined;
      this.installationDate = data.installationDate ?? undefined;
      this.isDocumentationCompleted = data.isDocumentationCompleted;
      this.previousSafetyAnchorPointId = data.previousSafetyAnchorPointId ?? undefined;
      this.nextSafetyAnchorPointId = data.nextSafetyAnchorPointId ?? undefined;
      this.documentationImage1ExternalId = data.documentationImage1ExternalId ?? undefined;
      this.documentationImage2ExternalId = data.documentationImage2ExternalId ?? undefined;
      this.documentationImage3ExternalId = data.documentationImage3ExternalId ?? undefined;
      this.documentationImage4ExternalId = data.documentationImage4ExternalId ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  siHaDocumentationId?: number;
  /**
  * @type {int64}
  */
  safetyHookId?: number;
  /**
  * @maximum 255
  */
  name?: string;
  /**
  * @type {int32}
  */
  screwLength?: number;
  /**
  */
  remark?: string;
  /**
  */
  isInstalledOnCounterBatten?: boolean;
  /**
  */
  installationRemark?: string;
  /**
  * @type {date-time}
  */
  installationDate?: string;
  /**
  */
  isDocumentationCompleted?: boolean;
  /**
  * @type {int64}
  */
  previousSafetyAnchorPointId?: number;
  /**
  * @type {int64}
  */
  nextSafetyAnchorPointId?: number;
  /**
  */
  documentationImage1ExternalId?: string;
  /**
  */
  documentationImage2ExternalId?: string;
  /**
  */
  documentationImage3ExternalId?: string;
  /**
  */
  documentationImage4ExternalId?: string;

  static toModel(dto: DeepPartial<SafetyAnchorPointDTO>): SafetyAnchorPointModel;
  static toModel(dto: DeepPartial<SafetyAnchorPointDTO> | undefined | null): SafetyAnchorPointModel | undefined;
  static toModel(dto: DeepPartial<SafetyAnchorPointDTO> | undefined | null): SafetyAnchorPointModel | undefined {
    return dto ? new SafetyAnchorPointModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SafetyAnchorPointModel> | SafetyAnchorPointModel): SafetyAnchorPointDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      siHaDocumentationId: unwrapped.siHaDocumentationId,
      safetyHookId: unwrapped.safetyHookId,
      name: unwrapped.name,
      screwLength: unwrapped.screwLength,
      remark: unwrapped.remark,
      isInstalledOnCounterBatten: unwrapped.isInstalledOnCounterBatten,
      installationRemark: unwrapped.installationRemark,
      installationDate: unwrapped.installationDate,
      isDocumentationCompleted: unwrapped.isDocumentationCompleted,
      previousSafetyAnchorPointId: unwrapped.previousSafetyAnchorPointId,
      nextSafetyAnchorPointId: unwrapped.nextSafetyAnchorPointId,
      documentationImage1ExternalId: unwrapped.documentationImage1ExternalId,
      documentationImage2ExternalId: unwrapped.documentationImage2ExternalId,
      documentationImage3ExternalId: unwrapped.documentationImage3ExternalId,
      documentationImage4ExternalId: unwrapped.documentationImage4ExternalId,
    } as SafetyAnchorPointDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SafetyAnchorPointModel, can not map to SafetyAnchorPointDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
